module.exports = __webpack_public_path__ + "static/UnclickPassedAway-395b86173409d808a9d85a8bd1d5fd11.png";